module.exports = {
  dev: {
    env: 'dev',
    name: '开发环境',
    domain: 'localhost',
    api: 'http://192.168.197.217:7666/',
    community: 'http://localhost:8801',
    platform: 'http://localhost:8800',
    platformData: 'http://localhost:8801/#/statsGateway',
    repair: 'http://192.168.197.217:7666/rfrepairsystem/checkSecurity.xhtml', // 运营数据后台
    device: 'http://192.168.197.217:7666/rfdevicesystem/checkSecurity.xhtml',
    wuye: 'http://192.168.197.217:8022/?action=login',
    kefu: 'http://192.168.197.217:8023/?action=login',
    guard: '', // 安防巡逻
    hr: 'http://192.168.197.217:8025/?action=login', // 已拆分为数据和培训
    pomp: 'http://localhost:8801/#/pompGateway',
    data: 'http://192.168.197.217:8028/?action=login', // 数据管家
    train: 'http://192.168.197.217:8025/?action=login', // 培训管家
    delivery: 'http://192.168.197.217:7666/rfreposystem/checkSecurity.xhtml', // 楼宇交付
    cctv: '', // 视频监控
    ad: '', // 广告平台
    place: '', // 场地管理
  },
  test: {
    env: 'test',
    name: '测试环境',
    domain: 'thinkinpower.net',
    api: 'http://tapi.guanjia.thinkinpower.net/',
    community: 'http://s.zizai.test.thinkinpower.net/',
    platform: 'http://p.zizai.test.thinkinpower.net/',
    jk:'http://s.zizai.test.thinkinpower.net/jk-platform',
    // platformData: 'http://s.zizai.test.thinkinpower.net/#/statsGateway', // 运营数据后台
    // platformData: 'http://stats.zizai.test.thinkinpower.net/#/', // 运营数据后台
    platformData: 'http://p.test.thinkinpower.net/rfInf/checkAppLoginUrl.shtml?appId=180700&urlPath=http://stats.zizai.test.thinkinpower.net/', // 运营数据后台
    repair: 'http://p.test.thinkinpower.net/rfInf/checkAppLoginUrl.shtml?appId=200100&urlPath=http://tgd.guanjia.thinkinpower.net/rfrepairsystem/index.xhtml', // 工单管家
    device: 'http://p.test.thinkinpower.net/rfInf/checkAppLoginUrl.shtml?appId=200200&urlPath=http://tgd.guanjia.thinkinpower.net/rfdevicesystem/index.xhtml', // 设备管家
    wuye: 'http://p.test.thinkinpower.net/rfInf/checkAppLoginUrl.shtml?appId=200500&urlPath=http://twy.guanjia.thinkinpower.net/magerlogin/ssoLoginPage', // 物业管家
    kefu: 'http://p.test.thinkinpower.net/rfInf/checkAppLoginUrl.shtml?appId=200600&urlPath=http://tkf.guanjia.thinkinpower.net/magerlogin/ssoLoginPage', // 客服管家
    guard: 'http://p.test.thinkinpower.net/rfInf/checkAppLoginUrl.shtml?appId=201000&urlPath=http://txg.guanjia.thinkinpower.net/magerlogin/ssoLoginPage', // 安防巡逻
    hr: 'http://thr.guanjia.thinkinpower.net/?action=login',
    pomp: 'http://s.zizai.test.thinkinpower.net/#/pompGateway',
    data: 'http://p.test.thinkinpower.net/rfInf/checkAppLoginUrl.shtml?appId=200700&urlPath=http://tbase.guanjia.thinkinpower.net/magerlogin/ssoLoginPage', // 数据管家
    train: 'http://p.test.thinkinpower.net/rfInf/checkAppLoginUrl.shtml?appId=200800&urlPath=http://tpx.guanjia.thinkinpower.net/magerlogin/ssoLoginPage', // 培训管家
    delivery: 'http://p.test.thinkinpower.net/rfInf/checkAppLoginUrl.shtml?appId=200300&urlPath=http://tgd.guanjia.thinkinpower.net/rfreposystem/index.xhtml', // 楼宇交付
    cctv: 'http://p.test.thinkinpower.net/rfInf/checkAppLoginUrl.shtml?appId=200900&urlPath=http://tvideo.guanjia.thinkinpower.net/magerlogin/ssoLoginPage', // 视频监控
    ad: 'http://p.test.thinkinpower.net/rfInf/checkAppLoginUrl.shtml?appId=201100&urlPath=http://tgd.guanjia.thinkinpower.net/steward-ad/ssoLogin.xhtml', // 广告平台
    place: 'http://p.test.thinkinpower.net/rfInf/checkAppLoginUrl.shtml?appId=201200&urlPath=http://tgd.guanjia.thinkinpower.net/steward-resource/ssoLogin.xhtml', // 场地管理
    corpID: 'wwbed5b3d4eaf1d106', // 企业的CorpID
    agentId: 1000006 // 企业的agentId
  },

  prerelease: {
    env: 'prerelease',
    name: '预发布环境',
    domain: 'thinkinpower.net',
    api: 'http://yapi.guanjia.thinkinpower.net/',
    community: 'http://s.zizai.pre.thinkinpower.net/',
    platform: 'http://p.zizai.pre.thinkinpower.net/',
    jk:'http://s.zizai.test.thinkinpower.net/jk-platform',
    platformData: 'http://p.pre.thinkinpower.net/rfInf/checkAppLoginUrl.shtml?appId=180700&urlPath=http://stats.zizai.pre.thinkinpower.net/', // 运营数据后台
    // platformData: 'http://stats.zizai.pre.thinkinpower.net/#/', // 运营数据后台
    repair: 'http://p.pre.thinkinpower.net/rfInf/checkAppLoginUrl.shtml?appId=200100&urlPath=http://ygd.guanjia.thinkinpower.net/rfrepairsystem/index.xhtml', // 工单管家
    device: 'http://p.pre.thinkinpower.net/rfInf/checkAppLoginUrl.shtml?appId=200200&urlPath=http://ygd.guanjia.thinkinpower.net/rfdevicesystem/index.xhtml', // 设备管家
    wuye: 'http://p.pre.thinkinpower.net/rfInf/checkAppLoginUrl.shtml?appId=200500&urlPath=http://ywy.guanjia.thinkinpower.net/magerlogin/ssoLoginPage', // 物业管家
    kefu: 'http://p.pre.thinkinpower.net/rfInf/checkAppLoginUrl.shtml?appId=200600&urlPath=http://ykf.guanjia.thinkinpower.net/magerlogin/ssoLoginPage', // 客服管家
    guard: 'http://p.pre.thinkinpower.net/rfInf/checkAppLoginUrl.shtml?appId=201000&urlPath=http://yxg.guanjia.thinkinpower.net/magerlogin/ssoLoginPage', // 安防巡逻
    hr: 'http://yhr.guanjia.thinkinpower.net/?action=login',
    pomp: 'http://s.zizai.pre.thinkinpower.net/#/pompGateway',
    data: 'http://p.pre.thinkinpower.net/rfInf/checkAppLoginUrl.shtml?appId=200700&urlPath=http://base.guanjia.thinkinpower.net/magerlogin/ssoLoginPage', // 数据管家
    train: 'http://p.pre.thinkinpower.net/rfInf/checkAppLoginUrl.shtml?appId=200800&urlPath=http://ypx.guanjia.thinkinpower.net/magerlogin/ssoLoginPage', // 培训管家
    delivery: 'http://p.pre.thinkinpower.net/rfInf/checkAppLoginUrl.shtml?appId=200300&urlPath=http://ygd.guanjia.thinkinpower.net/rfreposystem/index.xhtml', // 楼宇交付
    cctv: 'http://p.pre.thinkinpower.net/rfInf/checkAppLoginUrl.shtml?appId=200900&urlPath=http://yvideo.guanjia.thinkinpower.net/magerlogin/ssoLoginPage', // 视频监控
    ad: 'http://p.pre.thinkinpower.net/rfInf/checkAppLoginUrl.shtml?appId=201100&urlPath=http://ygd.guanjia.thinkinpower.net/steward-ad/ssoLogin.xhtml', // 广告平台
    place: 'http://p.pre.thinkinpower.net/rfInf/checkAppLoginUrl.shtml?appId=201200&urlPath=http://ygd.guanjia.thinkinpower.net/steward-resource/ssoLogin.xhtml', // 场地管理
  },
  prod: {
    env: 'prod',
    name: '',
    domain: 'thinkinpower.com',
    api: 'http://api.guanjia.thinkinpower.com/',
    community: 'http://s.zizai.thinkinpower.com',
    platform: 'http://p.zizai.thinkinpower.com',
    jk:'http://s.zizai.thinkinpower.com/jk-platform',
    platformData: 'http://p.thinkinpower.com/rfInf/checkAppLoginUrl.shtml?appId=180700&urlPath=http://stats.zizai.thinkinpower.com/', // 运营数据后台
    // platformData: 'http://stats.zizai.thinkinpower.com/#/', // 运营数据后台
    repair: 'http://p.thinkinpower.com/rfInf/checkAppLoginUrl.shtml?appId=200100&urlPath=http://gd.guanjia.thinkinpower.com/rfrepairsystem/index.xhtml', // 工单管家
    device: 'http://p.thinkinpower.com/rfInf/checkAppLoginUrl.shtml?appId=200200&urlPath=http://gd.guanjia.thinkinpower.com/rfdevicesystem/index.xhtml', // 设备管家
    wuye: 'http://p.thinkinpower.com/rfInf/checkAppLoginUrl.shtml?appId=200500&urlPath=http://wy.guanjia.thinkinpower.com/magerlogin/ssoLoginPage', // 物业管家
    kefu: 'http://p.thinkinpower.com/rfInf/checkAppLoginUrl.shtml?appId=200600&urlPath=http://kf.guanjia.thinkinpower.com/magerlogin/ssoLoginPage', // 客服管家
    guard: 'http://p.thinkinpower.com/rfInf/checkAppLoginUrl.shtml?appId=201000&urlPath=http://xg.guanjia.thinkinpower.com/magerlogin/ssoLoginPage', // 安防巡逻
    hr: 'http://hr.guanjia.thinkinpower.com/?action=login',
    pomp: 'http://s.zizai.thinkinpower.com/#/pompGateway',
    data: 'http://p.thinkinpower.com/rfInf/checkAppLoginUrl.shtml?appId=200700&urlPath=http://base.guanjia.thinkinpower.com/magerlogin/ssoLoginPage', // 数据管家
    train: 'http://p.thinkinpower.com/rfInf/checkAppLoginUrl.shtml?appId=200800&urlPath=http://px.guanjia.thinkinpower.com/magerlogin/ssoLoginPage', // 培训管家
    delivery: 'http://p.thinkinpower.com/rfInf/checkAppLoginUrl.shtml?appId=200300&urlPath=http://gd.guanjia.thinkinpower.com/rfreposystem/index.xhtml', // 楼宇交付
    cctv: 'http://p.thinkinpower.com/rfInf/checkAppLoginUrl.shtml?appId=200900&urlPath=http://video.guanjia.thinkinpower.com/magerlogin/ssoLoginPage', // 视频监控
    ad: 'http://p.thinkinpower.com/rfInf/checkAppLoginUrl.shtml?appId=201100&urlPath=http://gd.guanjia.thinkinpower.com/steward-ad/ssoLogin.xhtml', // 广告平台
    place: 'http://p.thinkinpower.com/rfInf/checkAppLoginUrl.shtml?appId=201200&urlPath=http://gd.guanjia.thinkinpower.com/steward-resource/ssoLogin.xhtml', // 场地管理
    corpID: 'ww1813e1da41715908', // 企业的CorpID
    agentId: 1000003 // 企业的agentId
  },
};


//////////////////
// WEBPACK FOOTER
// ./config/env.conf.js
// module id = 154
// module chunks = 5